import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// /admin/outreach moved under Communications → Sequences. Query params
// (?status=, ?new_custom_for=) ride along so deep links keep working.
export default function OutreachRedirect() {
  const { search } = useLocation();
  const sp = new URLSearchParams(search);
  sp.set('tab', 'sequences');
  return <Navigate to={`/admin/communications?${sp.toString()}`} replace />;
}
